/**
 * "Download on the App Store" badge (#3448).
 *
 * Apple's official black badge, unaltered. Source: Apple App Store Marketing
 * Tools badge API
 * (https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us),
 * downloaded 2026-09-11. Self-hosted under /images/ like every other asset
 * (never hot-linked), so it stays inside the CSP and never soft-404s.
 *
 * LINKS TO /ios, NEVER THE APPLE URL INLINE. /ios is a 302 in
 * `public/_redirects` to the App Store page — the direct store handoff. The
 * #3126 landing page lives at /app and carries the site's TEXT "get the app"
 * affordances (header, footer, login modal); the badge deliberately STAYS on
 * /ios (the store), so the store destination lives in one line. It is a plain
 * <a>, NOT a react-router <Link>: /ios has no client route, so a <Link> would
 * hit the SPA catch-all instead of the server redirect.
 *
 * The badge carries APPLE's mark, not ORO move's, so it does not touch Core
 * Rule 24's one-™-per-page count — the alt text is unmarked.
 *
 * Apple badge guidelines (developer.apple.com/app-store/marketing/guidelines):
 * no recoloring, no reshaping, minimum clear space around it. Rendered ~40px
 * tall inside a >=44px tap target (min-h-11).
 */

interface AppStoreBadgeProps {
  /** Extra classes on the anchor (layout / spacing at the call site). */
  className?: string;
}

export default function AppStoreBadge({ className = '' }: AppStoreBadgeProps) {
  return (
    <a
      href="/ios"
      className={`inline-flex items-center min-h-11 ${className}`}
      data-testid="app-store-badge"
    >
      <img
        src="/images/app-store-badge-black-en-us.svg"
        alt="Download on the App Store"
        // Intrinsic badge box (viewBox 119.66407×40, rounded to 120×40) so the
        // layout reserves space before CSS resolves; `h-10 w-auto` then renders
        // it ~40px tall at the badge's own aspect (#3448, George F4).
        width={120}
        height={40}
        className="h-10 w-auto"
      />
    </a>
  );
}
